import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { SUPPORT_ROUTE } from '../constants';

const PRIVACY_POLICY_URL = 'https://theezy.com/privacy';
const TERMS_URL = 'https://theezy.com/terms';

const Footer = () => {
    const location = useLocation();
    const year = new Date().getFullYear();

    return (
        <footer className="app-footer">
            <span className="app-footer-copyright">© {year} Theezy. All rights reserved.</span>
            <div className="app-footer-links">
                <a href={PRIVACY_POLICY_URL} target="_blank" rel="noopener noreferrer" className="app-footer-link">
                    Privacy Policy
                </a>
                <a href={TERMS_URL} target="_blank" rel="noopener noreferrer" className="app-footer-link">
                    Terms of Service
                </a>
                <Link to={SUPPORT_ROUTE.MAIN} state={{ from: location.pathname }} className="app-footer-link">
                    Need help?
                </Link>
            </div>
        </footer>
    );
};

export default Footer;